export default __webpack_public_path__ + "static/media/groupAccidentalInsurance.c37ee0a6.svg";